import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {GestioneClassiDocumentaliComponent} from './gestione-classi-documentali';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.gestione-classi-documentali', {
            url: '/gestione-classi-documentali',
            ncyBreadcrumb: {
                label: 'Gestione Classi Documentali',
                parent: 'home.admin'
            },
            data: {
                authorisationLevel: 2,
                pageTitle: 'Gestione Classi Documentali'
            },
            'views': {
                'homeContent': {
                    template: '<gestione-classi-documentali flex="100"></gestione-classi-documentali>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const GestioneClassiDocumentaliModule: string = ng
    .module('gestione-classi-documentali', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('gestioneClassiDocumentali', GestioneClassiDocumentaliComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-classi-documentali/gestione-classi-documentali.module.ts